<template>
  <div class="number-people-dropdown">
    <template v-if="!inManualEntry">
      <div class="number-people-dropdown-facade">
        <template v-if="options.length > 0">
          <span>{{ numGuests }} {{$tc('date_and_pax_stage.number_suffix', numGuests)}}</span>
          <div class="number-people-dropdown--caret"></div>
        </template>
        <template v-else>
          <div class="placeholder"></div>
        </template>
      </div>

      <select v-on:input="change" v-model="numGuests">
        <option v-for="option in options" v-bind:key="option.value" :value="option.value">
          {{ option.label }}
        </option>
        <option v-if="allowManualEntry" value="activateManualEntry">{{ max }}+ {{$tc('date_and_pax_stage.number_suffix', max)}}</option>
      </select>
    </template>
    <template v-else>
      <input type="number"
        pattern="\d*"
        v-on:keydown="handleManualInput"
        v-model.number="numGuests">

      <span>
        {{$tc('date_and_pax_stage.number_suffix', numGuests)}}
      </span>

    </template>
  </div>
</template>

<script>
  import { RangeProvider } from '../services/RangeProvider'

  export default {
    name: 'dropdownPaxSelector',
    props: [
      'value'
    ],
    data () {
      return {
        hardMaximum: 150,
        min: 1,
        max: 150,
        numGuests: this.value || this.defaultValue,
        allowManualEntry: true,
        inManualEntry: false,
        options: [],
        rangeManuallySet: false
      }
    },
    methods: {
      change (event) {
        const value = event.target.value

        if (value === 'activateManualEntry') {
          this.$nextTick(() => {
            this.numGuests = this.max
            this.inManualEntry = true
          })
        } else {
          this.numGuests = value
          this.$emit('input', value)
          this.inManualEntry = false
        }
      },

      buildOptions () {
        let options = []

        for (let i = 0; i <= this.max; i++) {
          if (i < this.min) {
            continue
          }

          options.push({
            label: i + ' ' + this.$tc('date_and_pax_stage.number_suffix', i),
            value: i
          })
        }

        return options
      },

      requestValue () {
        return this.numGuests
      },

      requestRange () {
        this.options = []

        this.rangeProvider.requestRange()
          .then((range) => {
            this.setMin(range.min)
            this.setMax(range.max)
          })
          .catch(() => {
            this.setMin(1)
            this.setMax(150)
          })
          .then(() => {
            this.ensureValueFitsRange()
            this.options = this.buildOptions()
          })
      },

      setDefault (defaultVal) {
        this.numGuests = defaultVal
      },

      setMin (min) {
        if (min < 1) {
          this.min = 1
        } else {
          this.min = min
        }
      },

      setMax (max) {
        if (max === null || max >= this.hardMaximum) {
          this.max = this.hardMaximum
          this.allowManualEntry = true
        } else {
          this.max = max
          this.allowManualEntry = false
        }
      },

      _isNumberKey (event) {
        return event.keyCode >= 48 && event.keyCode <= 57 && !event.shiftKey
      },

      _isNumPadKey (event) {
        return event.keyCode >= 96 && event.keyCode <= 105
      },

      _isArrowKey (event) {
        return event.keyCode >= 37 && event.keyCode <= 40
      },

      _isBackspaceKey (event) {
        // Backspace or delete key
        return event.keyCode === 8 || event.keyCode === 46
      },

      handleManualInput (event) {
        if (!this._isNumberKey(event) && !this._isNumPadKey(event) && !this._isArrowKey(event) && !this._isBackspaceKey(event)) {
          event.preventDefault()
          return false
        }
      },

      ensureValueFitsRange () {
        // If there's a value already set, check it fits with the new parameters.
        // If it's too big, set the value to the maximum.
        // If it's too small, set the value to the minimum.
        if (!this.numGuests) {
          this.numGuests = 2
        }

        if (this.numGuests > this.max) {
          this.numGuests = this.max
        } else if (this.numGuests < this.min) {
          this.numGuests = this.min
        }
      }
    },

    mounted () {
      this.rangeProvider = new RangeProvider(
        this.$root.booking
      )

      this.rangeProvider.setUrlOptions({
        source: this.$root.dmnOptions.from
      })
    },

    watch: {
      value: function (val) {
        this.numGuests = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// dropdownPaxSelector.vue?500d5bf4